import { FilterList } from '@mui/icons-material';
import { Badge, Button, Stack } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ViewOptions } from '@legacy/components/layout/FilterPanelLayout/components/MainContainer/components/ViewOptions';
import {
  IViewOptionsField,
  ViewOptionsChangeParameters,
} from '@legacy/components/layout/FilterPanelLayout/types';
import { useSidePanelDispatch } from '@legacy/components/layout/SidePanel';
import { Deck } from '@legacy/components/ui-components';
import { useSelectedFilterListInArray } from '@legacy/stores/FilterStore';

interface IResourcePlannerViewOptions {
  periodPicker: ReactElement;
  viewOptionsChange: (item: ViewOptionsChangeParameters[]) => void;
  viewOptionsFields: Array<IViewOptionsField>;
}

export const ResourcePlannerViewOptions = ({
  periodPicker,
  viewOptionsChange,
  viewOptionsFields,
}: IResourcePlannerViewOptions) => {
  const { t } = useTranslation(['viewOptions', 'resourcePlanner']);
  const sidePanelDispatch = useSidePanelDispatch();
  const selectedFilterList = useSelectedFilterListInArray();

  const toggleFilterPanel = () => {
    sidePanelDispatch?.({ type: 'TOGGLE_PANEL' });
  };

  return (
    <Deck.Item>
      <Stack
        alignItems="flex-end"
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
      >
        {periodPicker}
        <Stack direction="row" flexWrap="wrap" gap={2}>
          <ViewOptions
            viewOptionsFields={viewOptionsFields}
            viewOptionsChange={viewOptionsChange}
          />
          <Button
            onClick={toggleFilterPanel}
            startIcon={
              <Badge
                badgeContent={selectedFilterList.length}
                color="primary"
                data-automation-id="FilterContainerAddFilterCount"
              >
                <FilterList />
              </Badge>
            }
            variant="text"
          >
            {t('Filters', { ns: 'resourcePlanner' })}
          </Button>
        </Stack>
      </Stack>
    </Deck.Item>
  );
};
